import { RouteRecordRaw } from 'vue-router';

export const userRoutes: RouteRecordRaw[] = [
  {
    path: '/user',
    name: 'UserRoot',
    children: [
      {
        path: 'me',
        name: 'UserMePage',
        component: () => import('@/pages/company/CompanyUserPage.vue'),
      },
      {
        path: 'me/settings',
        name: 'UserSettingsPage',
        component: () => import('@/pages/user/UserSettings.vue'),
      },
    ],
  },
  {
    path: '/password',
    name: 'PasswordRoot',
    component: () => import('@/pages/user/auth/PasswordRoot.vue'),
    children: [
      {
        path: 'reset',
        name: 'ResetPassword',
        meta: { hideBreadcrumbs: true, hideSideNavigation: true },
        component: () => import('@/pages/user/auth/ResetPasswordPage.vue'),
      },
      {
        path: 'reset-confirm',
        name: 'ResetPasswordConfirm',
        meta: { hideBreadcrumbs: true, hideSideNavigation: true },
        component: () =>
          import('@/pages/user/auth/ResetPasswordConfirmPage.vue'),
      },
      {
        path: 'set/:token',
        name: 'SetNewNewPassword',
        meta: { hideBreadcrumbs: true, hideSideNavigation: true },
        component: () => import('@/pages/user/auth/SetNewPasswordPage.vue'),
      },
      {
        path: 'set-confirm',
        name: 'SetNewPasswordConfirm',
        meta: { hideBreadcrumbs: true, hideSideNavigation: true },
        component: () =>
          import('@/pages/user/auth/SetNewPasswordConfirmPage.vue'),
      },
    ],
  },
];
